import React, { useContext, useEffect, useState } from 'react'
import { StoresContext } from '@App/contexts'
import '../SongwriterSummaryView/index.scss'
import { observer } from 'mobx-react'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { useNavigate } from 'react-router'
import Navigation from '@App/navigation'
import PaginationComponent from '@Components/Tables/Pagination'
import { PaginationBody } from '@Entities/pagination'
import SongwriterSummaryView from '@Scenes/HomeScene/SongwriterSummaryView'

const SongwriterSummarySection = () => {
    const navigate = useNavigate()
    const limitItems = 6
    const { songwriterSearchStore } = useContext(StoresContext)
    const allSongwriters = songwriterSearchStore.songwriters
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        songwriterSearchStore.loadSongwriters({ page: 1, limit: limitItems }).finally(() => {
            if (songwriterSearchStore.songwriterCount === 1) {
                navigate(Navigation.songwriter.catalog.root(allSongwriters.content[0].id))
            }
            setLoading(false)
        })
    }, [])

    const handlePagination = (pagination: PaginationBody) => {
        songwriterSearchStore.loadSongwriters(pagination).finally()
    }

    return loading ? (
        <PointPreloader />
    ) : (
        <div>
            <SongwriterSummaryView songwriters={allSongwriters} />
            {allSongwriters && allSongwriters.totalElements > limitItems && (
                <PaginationComponent
                    limit={limitItems}
                    paginationPages={songwriterSearchStore.paginationInfo}
                    onChange={handlePagination}
                />
            )}
        </div>
    )
}
export default observer(SongwriterSummarySection)
